import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, authHeaders } from './apiHelpers';
import { SiteInfo } from './useSiteInfo';

export interface FeedbackMessageModel {
    feedbackMessageId: number;
    uniqueSiteId: number;
    driverId: string;
    message: string;
    createdDate: Date;
    siteName: string;
}

interface SendFeedbackPayload {
    message: string;
    driverId: string;
    siteInfo: SiteInfo;
}

export function useFeedbackMessages() {
    return useQuery<FeedbackMessageModel[], Error>({
        queryKey: ['feedbackMessages'],
        queryFn: () => apiFetch<FeedbackMessageModel[]>('api/feedbackmessages/get', {
            method: 'GET',
            headers: authHeaders()
        })
    });
}

export function useFeedbackMessage(id: number) {
    return useQuery<FeedbackMessageModel, Error>({
        queryKey: ['feedbackMessage', id],
        queryFn: () => apiFetch<FeedbackMessageModel>(`api/feedbackmessages/getbyid?id=${id}`, {
            method: 'GET',
            headers: authHeaders()
        }),
        enabled: id > 0
    });
}

export function useHandleFeedbackMessage() {
    const queryClient = useQueryClient();
    return useMutation<number, Error, number>({
        mutationFn: (id) => apiFetch<number>(`api/feedbackmessages/handle?id=${id}`, {
            method: 'PUT',
            headers: authHeaders()
        }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['feedbackMessages'] })
    });
}

export function useSendFeedbackMessage() {
    return useMutation<boolean, Error, SendFeedbackPayload>({
        mutationFn: ({ message, driverId, siteInfo }) => apiFetch<boolean>('api/feedbackmessages/send', {
            method: 'POST',
            body: JSON.stringify({
                MessageSent: false,
                Message: message,
                DriverId: driverId,
                SiteInfo: siteInfo
            }),
            headers: authHeaders()
        })
    });
}
